import InputErrorMsg from "@/app/components/common-form-builder/form-builder-helpers/InputErrorMsg";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { FieldValues, UseFormReturn } from "react-hook-form";

interface Props {
  form: UseFormReturn<FieldValues, any>;
  required: boolean;
  placeholder?: string;
}
const ConsultationMessage: React.FC<Props> = ({
  form,
  required,
  placeholder = null,
}) => {
  const t = useTranslation();
  return (
    <>
      <textarea
        {...form.register("message", {
          required: required && t.this_field_is_required,
        })}
        className="consult-message"
        rows={5}
        placeholder={placeholder ?? t.write_your_message_here}
      />
      <div style={{ paddingInlineStart: 16 }}>
        {form.formState.errors.message && (
          <InputErrorMsg
            errorMsg={form.formState.errors.message?.message as string}
          />
        )}
      </div>
    </>
  );
};

export default ConsultationMessage;
